// extracted by mini-css-extract-plugin
export default {"topBarWrapper":"TopBar_topBarWrapper__Ikrz-","topBar":"TopBar_topBar__nE7u5","topBarRightPlaceholder":"TopBar_topBarRightPlaceholder__7faPC"};